export default __webpack_public_path__ + "static/13-897c9aa8add84af6dd7c49a2920202a4.jpg";